function dropdown() {
    const mediaQuery = window.matchMedia('(max-width: 767px)');

    const head = document.querySelector('.gh-navigation');
    const menu = head.querySelector('.gh-navigation-menu');
    const nav = menu?.querySelector('.nav');
    if (!nav) return;

    const logo = document.querySelector('.gh-navigation-logo');
    const navHTML = nav.innerHTML;

    // Create submenus for items with -- prefix
    createSubmenus();

    if (mediaQuery.matches) {
        const items = nav.querySelectorAll('li');
        items.forEach(function (item, index) {
            item.style.transitionDelay = `${0.03 * (index + 1)}s`;
        });
    }

    const makeDropdown = function () {
        if (mediaQuery.matches) return;
        const submenuItems = [];

        while ((nav.offsetWidth + 64) > menu.offsetWidth) {
            if (nav.lastElementChild) {
                submenuItems.unshift(nav.lastElementChild);
                nav.lastElementChild.remove();
            } else {
                break;
            }
        }

        if (!submenuItems.length) {
            head.classList.add('is-dropdown-loaded');
            return;
        }

        const toggle = document.createElement('button');
        toggle.setAttribute('class', 'gh-more-toggle gh-icon-button');
        toggle.setAttribute('aria-label', 'More');
        toggle.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" fill="currentColor"><path d="M21.333 16c0-1.473 1.194-2.667 2.667-2.667v0c1.473 0 2.667 1.194 2.667 2.667v0c0 1.473-1.194 2.667-2.667 2.667v0c-1.473 0-2.667-1.194-2.667-2.667v0zM13.333 16c0-1.473 1.194-2.667 2.667-2.667v0c1.473 0 2.667 1.194 2.667 2.667v0c0 1.473-1.194 2.667-2.667 2.667v0c-1.473 0-2.667-1.194-2.667-2.667v0zM5.333 16c0-1.473 1.194-2.667 2.667-2.667v0c1.473 0 2.667 1.194 2.667 2.667v0c0 1.473-1.194 2.667-2.667 2.667v0c-1.473 0-2.667-1.194-2.667-2.667v0z"></path></svg>';

        const wrapper = document.createElement('div');
        wrapper.setAttribute('class', 'gh-dropdown');

        if (submenuItems.length >= 10) {
            head.classList.add('is-dropdown-mega');
            wrapper.style.gridTemplateRows = `repeat(${Math.ceil(submenuItems.length / 2)}, 1fr)`;
        } else {
            head.classList.remove('is-dropdown-mega');
        }

        submenuItems.forEach(function (child) {
            wrapper.appendChild(child);
        });

        toggle.appendChild(wrapper);
        nav.appendChild(toggle);

        const toggleRect = toggle.getBoundingClientRect();
        const documentCenter = window.innerWidth / 2;

        if (toggleRect.left < documentCenter) {
            wrapper.classList.add('is-left');
        }

        head.classList.add('is-dropdown-loaded');

        window.addEventListener('click', function (e) {
            if (head.classList.contains('is-dropdown-open')) {
                head.classList.remove('is-dropdown-open');
            } else if (toggle.contains(e.target)) {
                head.classList.add('is-dropdown-open');
            }
        });
    }

    imagesLoaded(logo, function () {
        makeDropdown();
    });

    window.addEventListener('load', function () {
        if (!logo) {
            makeDropdown();
        }
    });

    window.addEventListener('resize', function () {
        setTimeout(() => {
            nav.innerHTML = navHTML;
            createSubmenus();
            makeDropdown();
        }, 1);
    });

    function createSubmenus() {
        const navItems = document.querySelectorAll('.gh-navigation-menu .nav li');
        let prevItem = null;
        let subItems = [];

        navItems.forEach((item, i) => {
            const label = item?.children[0]?.innerHTML;
            
            if (label && label.indexOf('-') === 0) {
                // This is a submenu item
                subItems.push({
                    link: item.innerHTML,
                    classes: item.classList,
                    element: item
                });
            } else {
                // This is a main menu item
                if (subItems.length > 0 && prevItem) {
                    // Create submenu for previous item
                    createSubmenuForItem(prevItem, subItems);
                }
                // Reset for next group
                prevItem = item;
                subItems = [];
            }
        });

        // Handle last group if it has subitems
        if (subItems.length > 0 && prevItem) {
            createSubmenuForItem(prevItem, subItems);
        }

        // Initialize dropdown functionality
        initializeDropdowns();
    }

    function createSubmenuForItem(parentItem, subItems) {
        // Create submenu list
        const subNavUl = document.createElement('ul');
        subNavUl.className = 'nav';
        subNavUl.setAttribute('role', 'menu');
        subNavUl.setAttribute('aria-hidden', 'true');

        // Add sub items to the list and remove original items
        subItems.forEach((subItem, index) => {
            const li = document.createElement('li');
            li.className = subItem.classes.toString();
            li.setAttribute('role', 'none');
            
            // Update the inner HTML and add proper role
            li.innerHTML = subItem.link.replace('- ', '');
            const linkElement = li.querySelector('a');
            if (linkElement) {
                linkElement.setAttribute('role', 'menuitem');
                linkElement.setAttribute('tabindex', '-1');
            }
            
            subNavUl.appendChild(li);
            
            // Remove original item from nav
            subItem.element.remove();
        });

        // Create dropdown toggle button
        const dropdownToggle = document.createElement('button');
        dropdownToggle.className = 'nav-dropdown-toggle';
        dropdownToggle.setAttribute('type', 'button');
        dropdownToggle.setAttribute('aria-expanded', 'false');
        dropdownToggle.setAttribute('aria-haspopup', 'true');
        dropdownToggle.setAttribute('aria-label', 'Toggle submenu');
        dropdownToggle.innerHTML = '<svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L5 5L9 1" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

        // Keep the main link functional - just ensure it's not prevented
        const parentLink = parentItem.children[0];
        if (parentLink) {
            // Don't modify the link's href or prevent its navigation
            parentLink.style.paddingRight = '24px'; // Make room for the dropdown button
        }

        // Position the dropdown toggle
        parentItem.style.position = 'relative';
        dropdownToggle.style.position = 'absolute';
        dropdownToggle.style.right = '0';
        dropdownToggle.style.top = '50%';
        dropdownToggle.style.transform = 'translateY(-50%)';
        
        // Add dropdown toggle and submenu to parent item
        parentItem.appendChild(dropdownToggle);
        parentItem.appendChild(subNavUl);
        
        // Add classes to parent item
        parentItem.classList.remove('nav-current');
        parentItem.classList.add('subnav', 'nav-wrapper');
    }

    function initializeDropdowns() {
        const navTriggers = document.querySelectorAll('.subnav');
        const subnavUls = document.querySelectorAll('.subnav ul');

        function hideSubmenusExcept(exceptIndex) {
            subnavUls.forEach((subnavUl, index) => {
                if (index !== exceptIndex) {
                    subnavUl.classList.remove('show-nav');
                    subnavUl.setAttribute('aria-hidden', 'true');
                    
                    const navTrigger = navTriggers[index];
                    const dropdownToggle = navTrigger.querySelector('.nav-dropdown-toggle');
                    
                    // Remove is-open class from parent
                    navTrigger.classList.remove('is-open');
                    
                    if (dropdownToggle) {
                        dropdownToggle.setAttribute('aria-expanded', 'false');
                    }
                    
                    // Reset tabindex for menu items
                    const menuItems = subnavUl.querySelectorAll('a[role="menuitem"]');
                    menuItems.forEach(item => item.setAttribute('tabindex', '-1'));
                }
            });
        }

        function showSubmenu(index) {
            const subnavUl = subnavUls[index];
            const navTrigger = navTriggers[index];
            const dropdownToggle = navTrigger.querySelector('.nav-dropdown-toggle');
            
            subnavUl.classList.add('show-nav');
            subnavUl.setAttribute('aria-hidden', 'false');
            
            // Add is-open class to parent
            navTrigger.classList.add('is-open');
            
            if (dropdownToggle) {
                dropdownToggle.setAttribute('aria-expanded', 'true');
            }
            
            // Enable keyboard navigation for menu items
            const menuItems = subnavUl.querySelectorAll('a[role="menuitem"]');
            menuItems.forEach(item => item.setAttribute('tabindex', '0'));
        }

        function toggleSubmenu(index) {
            const subnavUl = subnavUls[index];
            const isOpen = subnavUl.classList.contains('show-nav');
            
            if (isOpen) {
                hideSubmenusExcept(-1);
            } else {
                hideSubmenusExcept(index);
                showSubmenu(index);
            }
        }

        navTriggers.forEach((navTrigger, index) => {
            const dropdownToggle = navTrigger.querySelector('.nav-dropdown-toggle');
            const mainLink = navTrigger.querySelector('a');
            
            if (!dropdownToggle) return;
            
            // Dropdown toggle click handler
            dropdownToggle.addEventListener('click', (event) => {
                event.preventDefault();
                event.stopPropagation();
                toggleSubmenu(index);
            });
            
            // Dropdown toggle keyboard handlers
            dropdownToggle.addEventListener('keydown', (event) => {
                if (event.key === 'Enter' || event.key === ' ') {
                    event.preventDefault();
                    toggleSubmenu(index);
                    event.stopPropagation();
                } else if (event.key === 'Escape') {
                    hideSubmenusExcept(-1);
                }
            });

            // Hover functionality for better UX (progressive enhancement)
            let hoverTimeout;
            
            navTrigger.addEventListener('mouseenter', () => {
                clearTimeout(hoverTimeout);
                hoverTimeout = setTimeout(() => {
                    hideSubmenusExcept(index);
                    showSubmenu(index);
                }, 200); // Small delay to prevent accidental triggers
            });
            
            navTrigger.addEventListener('mouseleave', () => {
                clearTimeout(hoverTimeout);
                hoverTimeout = setTimeout(() => {
                    hideSubmenusExcept(-1);
                }, 300); // Longer delay to allow moving to submenu
            });

            // Keep submenu open when hovering over it
            const submenu = subnavUls[index];
            submenu.addEventListener('mouseenter', () => {
                clearTimeout(hoverTimeout);
            });
            
            submenu.addEventListener('mouseleave', () => {
                hoverTimeout = setTimeout(() => {
                    hideSubmenusExcept(-1);
                }, 300);
            });
            
            // Keyboard navigation within submenus
            submenu.addEventListener('keydown', (event) => {
                const menuItems = Array.from(submenu.querySelectorAll('a[role="menuitem"]'));
                const currentIndex = menuItems.indexOf(event.target);
                
                switch (event.key) {
                    case 'Escape':
                        hideSubmenusExcept(-1);
                        dropdownToggle.focus();
                        break;
                    case 'ArrowDown':
                        event.preventDefault();
                        const nextIndex = (currentIndex + 1) % menuItems.length;
                        menuItems[nextIndex].focus();
                        break;
                    case 'ArrowUp':
                        event.preventDefault();
                        const prevIndex = currentIndex > 0 ? currentIndex - 1 : menuItems.length - 1;
                        menuItems[prevIndex].focus();
                        break;
                    case 'Home':
                        event.preventDefault();
                        menuItems[0].focus();
                        break;
                    case 'End':
                        event.preventDefault();
                        menuItems[menuItems.length - 1].focus();
                        break;
                }
            });
        });

        // Close dropdowns when clicking outside
        document.addEventListener('click', () => {
            hideSubmenusExcept(-1);
        });
        
        // Close dropdowns on escape key
        document.addEventListener('keydown', (event) => {
            if (event.key === 'Escape') {
                hideSubmenusExcept(-1);
            }
        });
    }
}
